import { LoaderCircle } from "components/loader";

import { circleLoaderContainerStyles, circleLoaderStyles, loaderContainerStyles } from "./styles";

export const CannedResponsesLoader: React.FC = () => (
  <div css={loaderContainerStyles}>
    <div css={circleLoaderContainerStyles}>
      <LoaderCircle css={circleLoaderStyles} isVisible />
    </div>
    <span>Loading more canned responses…</span>
  </div>
);
